import { render, staticRenderFns } from "./ListAlbums.vue?vue&type=template&id=18d831ba&"
import script from "./ListAlbums.vue?vue&type=script&lang=js&"
export * from "./ListAlbums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports